import { render, staticRenderFns } from "./ProfileQuestionCard.vue?vue&type=template&id=4bf8bac8&scoped=true"
import script from "./ProfileQuestionCard.vue?vue&type=script&lang=js"
export * from "./ProfileQuestionCard.vue?vue&type=script&lang=js"
import style0 from "./ProfileQuestionCard.vue?vue&type=style&index=0&id=4bf8bac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf8bac8",
  null
  
)

export default component.exports